import { Injectable } from '@angular/core';

import { BaseEditCopyService, HttpService, NotificationService } from '../../../tms-shared';

@Injectable({
  providedIn: 'root',
})
export abstract class TmsWebBaseEditCopyService<T, TEdit> extends BaseEditCopyService<T, TEdit> {
  protected constructor(
    protected baseRoute: string,
    public name: string,
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super(baseRoute, name, httpService, notificationService);
  }

  protected get apiUrl() {
    return `TmsWeb/${this.baseRoute}`;
  }
}
